export default __webpack_public_path__ + "static/media/small.ca767f68.jpg";